import { useSelector } from 'react-redux';
import type { RootState } from 'store';

/**
 * Hook to get the current online/offline status
 *
 * The online status is managed by network monitoring and dispatches Redux
 * actions from browser events, service-worker messages, and recovery polling.
 * This hook simply reads from the Redux store.
 *
 * Returns true when online, false when offline
 */
export const useOnlineStatus = () => {
  return useSelector((state: RootState) => state.connectionState.isOnline);
};
